require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.object.define-property");

(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['exports'], factory);else if ('undefined' != typeof exports) factory(exports);else {
    var mod = {
      exports: {}
    };
    factory(mod.exports), global.option = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: !0
  }), exports["default"] = function (name, description, defaultValue, init) {
    var _this = this,
        usage = [],
        assignShort = function assignShort(n, options, _short) {
      return options.find(function (flagName) {
        return flagName.usage[0] === _short;
      }) && (_short = n.charAt(0).toUpperCase()), [_short, n];
    };

    switch (name.constructor) {
      case String:
        usage = assignShort(name, this.details.options, name.charAt(0));
        break;

      case Array:
        usage = usage.concat(name);
        break;

      default:
        throw new Error('Invalid name for option');
    }

    if (0 < usage.length && 1 < usage[0].length) throw new Error('Short version of option is longer than 1 char');
    var optionDetails = {
      defaultValue: defaultValue,
      usage: usage,
      description: description
    },
        matches = this.details.options.filter(function (item) {
      return item.usage.constructor === String && (item.usage = _this.usageStringToArrayForm(item.usage)), item.usage[1] === usage[1];
    });

    if (0 === matches.length) {
      var defaultIsWrong;

      if (defaultIsWrong = !1 === defaultValue || null === defaultValue || void 0 === defaultValue, !defaultIsWrong) {
        optionDetails.init = 'function' == typeof init ? init : this.handleType(defaultValue)[1];
      }

      this.details.options.push(optionDetails);
    }

    return this;
  };
});